if (!customElements.get('bitig-book-rail')) {
  customElements.define('bitig-book-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.bitig-store-book-rail');
      this.controls = this.querySelector('.bitig-rail-controls');
      if (!this.rail || !this.controls) return;
      this.previous = this.controls.querySelector('[data-direction="previous"]');
      this.next = this.controls.querySelector('[data-direction="next"]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button || button.disabled) return;
        const direction = button.dataset.direction === 'next' ? 1 : -1;
        this.rail.scrollBy({
          left: direction * this.rail.clientWidth * 0.85,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, options);
      this.rail.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.updateControls());
      this.resize.observe(this.rail);
      this.updateControls();
    }

    updateControls() {
      const overflow = this.rail.scrollWidth - this.rail.clientWidth;
      this.controls.hidden = overflow <= 2;
      this.previous.disabled = this.rail.scrollLeft <= 2;
      this.next.disabled = this.rail.scrollLeft >= overflow - 2;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}
